import { Alert } from "@mui/material";
import { needsMessage, useCan } from "modules/settings/accessRoles";
import {
  AppBar,
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import EditVendorForm from "../Vendors/modals/EditVendorForm";
import VendorBaseChargesCard from "../../modules/vendor/components/VendorBaseChargesCard";
import VendorRiderRatesTable from "../../modules/vendor/components/VendorRiderRatesTable";
import VendorPropertiesTable from "../../modules/vendor/components/VendorPropertiesTable";
import {
  getVendorRiderRatesByVendorUuid,
  getVendorBaseChargesByVendorUuid,
  getPropertiesByVendorUuid,
} from "../../modules/vendor/api/actions";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vendor-tabpanel-${index}`}
      aria-labelledby={`vendor-tab-${index}`}
    >
      {value === index && <Box pt={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function VendorTabbedSections(props) {
  const { vendor, onSaveSuccess } = props;
  const canEditVendors = useCan()("editRecords");
  // Without Admin the form still shows the vendor, but saving is blocked.
  const submitVendorEdit = canEditVendors ? props.submitVendorEdit : async () => { throw new Error(needsMessage("editRecords")); };
  const [tab, setTab] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (vendor && vendor.uuid) {
      dispatch(getVendorRiderRatesByVendorUuid(vendor.uuid));
      dispatch(getVendorBaseChargesByVendorUuid(vendor.uuid));
      dispatch(getPropertiesByVendorUuid(vendor.uuid));
    }
  }, [dispatch, vendor]);

  const handleSaveSuccess = () => {
    if (onSaveSuccess) {
      onSaveSuccess();
    }
  };

  return (
    <div>
      <AppBar position="static" color="default">
        <Tabs
          value={tab}
          onChange={(event, newValue) => setTab(newValue)}
          aria-label="Vendor detail tabs"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Vendor Info" id="vendor-tab-0" />
          <Tab label="Rider Rates" id="vendor-tab-1" />
          <Tab label="Properties" id="vendor-tab-2" />
        </Tabs>
      </AppBar>
      <TabPanel value={tab} index={0}>
        {!canEditVendors && <Alert severity="info" sx={{ mb: 2 }}>{needsMessage("editRecords")} You can view this vendor, but your changes won't be saved.</Alert>}
        <EditVendorForm
          vendor={vendor}
          handleClose={handleSaveSuccess}
          submitVendorEdit={submitVendorEdit}
        />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <VendorBaseChargesCard vendor={vendor} />
        <VendorRiderRatesTable vendor={vendor} />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <VendorPropertiesTable vendor={vendor} />
      </TabPanel>
    </div>
  );
}

VendorTabbedSections.propTypes = {
  vendor: PropTypes.object.isRequired,
  submitVendorEdit: PropTypes.func.isRequired,
  onSaveSuccess: PropTypes.func,
};
